import {Component, Inject, Input, OnInit} from '@angular/core';
import {KongService} from '../../kong.service';
import {MatDialog} from '@angular/material/dialog';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA} from '@angular/material';
import {ApplicationVersionChangeConfirmationComponent} from '../../deploymentplan/deploymentplan.component';
import {ConfService} from '../../conf.service';

@Component({
  selector: 'app-authorization-types',
  templateUrl: './authorization-types.component.html',
  styleUrls: ['./authorization-types.component.scss']
})
export class AuthorizationTypesComponent implements OnInit {

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  settingsData: any;
  authTypes: any;
  authTypeConfig = [];
  origAuthTypeConfig = [];
  adminEnvironmentsLength = 0;

  componentLoading = true;
  updating = false;

  constructor(private confPost: ConfService, public dialog: MatDialog, public platform: LeftpanelComponent) { }

  async ngOnInit() {
    if (this.platform.settingsData === null || this.platform.settingsData === undefined) {
      await this.platform.getSettingsData(this.partner, this.account, false);
    }
    this.settingsData = this.platform.settingsData;
    if (this.settingsData && this.settingsData['body'] && this.settingsData['body'] !== undefined && this.settingsData['body'] !== null) {
      this.confPost.getData('services', 'services', 'v1', 'kongAuthorizationTypes', '').subscribe(async response => {
        this.authTypes = response;
        this.adminEnvironmentsLength = this.settingsData['body'][0]['environments'].length;
        for (const environment of this.settingsData['body'][0]['environments']) {
          if (environment['name'] === this.partner) {
            const config = environment.authTypes ? environment.authTypes : [];
            for (const value of this.authTypes) {
              if (config.includes(value.id)) {
                this.authTypeConfig.push({name: value.displayName, id: value.id, checked: true});
              } else {
                this.authTypeConfig.push({name: value.displayName, id: value.id, checked: false});
              }
            }
            this.origAuthTypeConfig = JSON.parse(JSON.stringify(this.authTypeConfig));
          }
        }
        this.componentLoading = false;
      }, error => {
        this.platform.openSnackBar('Unable to retrieve configurations for your account. Please try again after some time', 'Error', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    }

  }

  async showDialog() {
    const dialogRef = this.dialog.open(AuthTypesSaveConfirmationComponent, {
      width: '60%'
    });
    const result = await dialogRef.afterClosed().toPromise();
    if (result && result === 'admin' || result === 'environments') {
      const adminOnly = result === 'admin';
      const authTypes = [];
      for (const type of this.authTypeConfig) {
        if (type.checked) {
          authTypes.push(type.id);
        }
      }
      this.updateSettings(authTypes, adminOnly);
    }
  }

  updateSettings(authTypes, adminOnly) {
    let index = 0;
    this.updating = true;
    for (const env1 of this.settingsData['body'][0]['environments']) {
      if (env1 && env1 !== null && env1 !== undefined) {
        if ((adminOnly && env1['name'] === this.partner) || !adminOnly) {
          this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(async response1 => {
            if (response1 && response1['body'] && response1.status === 200) {
              for (const env2 of response1['body'][0]['environments']) {
                if (env2 && env2 !== null && env2 !== undefined) {
                  if ((adminOnly && env2['name'] === this.partner) || !adminOnly) {
                    env2['authTypes'] = authTypes;
                  }
                }
              }
              await this.patchConfiguration('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(async resp => {
                index += 1;
                if (index === this.adminEnvironmentsLength || (adminOnly && index === 1)) {
                  for (const env3 of this.settingsData['body'][0]['environments']) {
                    if ((adminOnly && env3['name'] === this.partner) || !adminOnly) {
                      env3['authTypes'] = authTypes;
                    }
                  }
                  this.origAuthTypeConfig = JSON.parse(JSON.stringify(this.authTypeConfig));
                  this.updating = false;
                  this.platform.openSnackBar('Configuration updated successfully.', 'Success', {
                    duration: 4000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                }
              }, error => {
                this.platform.openSnackBar('Error while updating settings for environment.', 'Error', {
                  duration: 10000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              });
            }
          }, error => {
            this.platform.openSnackBar('Unable to update settings for environment: ' + env1['name'], 'Error', {
              duration: 10000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        }
      }
    }
  }

  patchConfiguration(partner, account, version, entity, id, payload) {
    return new Promise((resolve, reject) => {
      this.platform.patchEntityData(partner, account, version, entity, id, payload).then(resp => {
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }
}

@Component({
  selector: 'auth-types-save-confirmation',
  templateUrl: 'auth-types-save-confirmation.component.html',
  styleUrls: ['auth-types-save-confirmation.component.css']
})
export class AuthTypesSaveConfirmationComponent {
  copyData = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

}
